import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';
import 'helpers/initFA';
import 'i18n/i18n';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN_KEY,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: 0.1,//10% of traces
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.05, //5% of sessions
  enabled: process.env.REACT_APP_NODE_ENV === 'production'
});

const root = createRoot(document.getElementById('main'));
root.render(
  <React.StrictMode>
    <Main>
      <App />
    </Main>
  </React.StrictMode>
);
